"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractGetByIdGrouped = exports.AbstractGroupedGet = exports.BATCH_TIMEOUT = exports.BATCH_MAX_SIZE = void 0;
const lodash_1 = require("lodash");
const Config_1 = require("../../Config");
exports.BATCH_MAX_SIZE = 100;
exports.BATCH_TIMEOUT = 500;
class AbstractGroupedGet {
    constructor(env, col, subCol) {
        this.env = env;
        this.col = col;
        this.subCol = subCol;
        this.requests = [];
        this.timer = null;
        this.init = (uid, parent = '') => {
            const request = this.requests.find((r) => r.parent === parent && r.uid === uid);
            if (!request) {
                this.requests.push({ parent, uid });
            }
        };
        this.executeTimed = async () => {
            if (!this.timer) {
                this.timer = new Promise((resolve) => setTimeout(async () => {
                    await this.executeRequests();
                    resolve();
                }, exports.BATCH_TIMEOUT));
            }
            await this.timer;
            this.timer = null;
        };
        this.createUrl = () => {
            throw new Error('Method not implemented.');
        };
        this.executeRequests = async () => {
            throw new Error('Method not implemented.');
        };
    }
}
exports.AbstractGroupedGet = AbstractGroupedGet;
class AbstractGetByIdGrouped extends AbstractGroupedGet {
    constructor() {
        super(...arguments);
        this.createUrl = () => {
            const requests = this.requests.splice(0, exports.BATCH_MAX_SIZE);
            const params = {
                collection: this.col,
                uids: requests.map((r) => r.uid),
            };
            if (this.subCol) {
                const parents = requests.map((r) => r.parent);
                (0, lodash_1.set)(params, 'parentUids', parents);
                (0, lodash_1.set)(params, 'subCollection', this.subCol);
            }
            const url = (0, Config_1.getManyByIdUrl)(this.env);
            return { requests, url, params };
        };
    }
}
exports.AbstractGetByIdGrouped = AbstractGetByIdGrouped;
